import { TravelLocation } from 'Store/profile/types';
import type { Pos } from 'Store/profile/user.types';

export type PassportState = {
  is_traveling: boolean | null;
  travel_pos: Pos | null;
  travel_location_info: TravelLocation | null;
};

const initialState: PassportState = {
  is_traveling: null,
  travel_pos: null,
  travel_location_info: null,
};

export default initialState;
